/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {PersonalAuthDTO} from '../model/personalAuthDTO';
import {PersonalAuthNewsletterDTO} from '../model/personalAuthNewsletterDTO';
import {PersonalChangeEmailDTO} from '../model/personalChangeEmailDTO';
import {PersonalDataDTO} from '../model/personalDataDTO';
import {PersonalNewslettersStatus} from '../model/personalNewslettersStatus';
import {PersonalUpdateDTO} from '../model/personalUpdateDTO';
import {UpdateExportPartnerAuthorizationDTO} from '../model/updateExportPartnerAuthorizationDTO';
import {UpdateStatusNewsletterDTO} from '../model/updateStatusNewsletterDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EnginePublicPersonalService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


     /**
     * anonymizationPersonal
     *
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public anonymizationPersonalUsingDELETE(token?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public anonymizationPersonalUsingDELETE(token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public anonymizationPersonalUsingDELETE(token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public anonymizationPersonalUsingDELETE(token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/public/v1/personal/anonymization/personal`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * anonymizationTable
     *
     * @param xDataStoreID X-DataStoreID
     * @param tables tables
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public anonymizationTableUsingDELETE(xDataStoreID: string, tables: Array<string>, token?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public anonymizationTableUsingDELETE(xDataStoreID: string, tables: Array<string>, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public anonymizationTableUsingDELETE(xDataStoreID: string, tables: Array<string>, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public anonymizationTableUsingDELETE(xDataStoreID: string, tables: Array<string>, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling anonymizationTableUsingDELETE.');
        }

        if (tables === null || tables === undefined) {
            throw new Error('Required parameter tables was null or undefined when calling anonymizationTableUsingDELETE.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tables) {
            tables.forEach((element) => {
                queryParameters = queryParameters.append('tables', <any>element);
            })
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/public/v1/personal/anonymization/partner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * anonymizationTenant
     *
     * @param xDataStoreID X-DataStoreID
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public anonymizationTenantUsingDELETE(xDataStoreID: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
     public anonymizationTenantUsingDELETE(xDataStoreID: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
     public anonymizationTenantUsingDELETE(xDataStoreID: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
     public anonymizationTenantUsingDELETE(xDataStoreID: string, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling anonymizationTenantUsingDELETE.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.delete<boolean>(`${this.basePath}/api/public/v1/personal/anonymization/tenant`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * authenticationEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param personalAuthDTO personalAuthDTO
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public authenticationEmailUsingPOST(xDataStoreID: string, personalAuthDTO: PersonalAuthDTO, X_PARTNER_ID?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
     public authenticationEmailUsingPOST(xDataStoreID: string, personalAuthDTO: PersonalAuthDTO, X_PARTNER_ID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
     public authenticationEmailUsingPOST(xDataStoreID: string, personalAuthDTO: PersonalAuthDTO, X_PARTNER_ID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
     public authenticationEmailUsingPOST(xDataStoreID: string, personalAuthDTO: PersonalAuthDTO, X_PARTNER_ID?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling authenticationEmailUsingPOST.');
         }

         if (personalAuthDTO === null || personalAuthDTO === undefined) {
             throw new Error('Required parameter personalAuthDTO was null or undefined when calling authenticationEmailUsingPOST.');
         }


         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
             headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<any>(`${this.basePath}/api/public/v1/personal/authentication/email`,
             personalAuthDTO,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * authenticationNewsletterEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param personalAuthNewsletterDTO personalAuthNewsletterDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public authenticationNewsletterEmailUsingPOST(xDataStoreID: string, personalAuthNewsletterDTO: PersonalAuthNewsletterDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public authenticationNewsletterEmailUsingPOST(xDataStoreID: string, personalAuthNewsletterDTO: PersonalAuthNewsletterDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public authenticationNewsletterEmailUsingPOST(xDataStoreID: string, personalAuthNewsletterDTO: PersonalAuthNewsletterDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public authenticationNewsletterEmailUsingPOST(xDataStoreID: string, personalAuthNewsletterDTO: PersonalAuthNewsletterDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling authenticationNewsletterEmailUsingPOST.');
        }

        if (personalAuthNewsletterDTO === null || personalAuthNewsletterDTO === undefined) {
            throw new Error('Required parameter personalAuthNewsletterDTO was null or undefined when calling authenticationNewsletterEmailUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/public/v1/personal/newsletters/authentication/email`,
            personalAuthNewsletterDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * changeEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param emailChange emailChange
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public changeEmailUsingPOST(xDataStoreID: string, emailChange: PersonalChangeEmailDTO, token?: string, observe?: 'body', reportProgress?: boolean): Observable<PersonalDataDTO>;
     public changeEmailUsingPOST(xDataStoreID: string, emailChange: PersonalChangeEmailDTO, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PersonalDataDTO>>;
     public changeEmailUsingPOST(xDataStoreID: string, emailChange: PersonalChangeEmailDTO, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PersonalDataDTO>>;
     public changeEmailUsingPOST(xDataStoreID: string, emailChange: PersonalChangeEmailDTO, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling changeEmailUsingPOST.');
         }

         if (emailChange === null || emailChange === undefined) {
             throw new Error('Required parameter emailChange was null or undefined when calling changeEmailUsingPOST.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<PersonalDataDTO>(`${this.basePath}/api/public/v1/personal/infos/change/email`,
             emailChange,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * emailExist
     *
     * @param xDataStoreID X-DataStoreID
     * @param newEmail newEmail
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public emailExistUsingPOST(xDataStoreID: string, newEmail: string, token: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
     public emailExistUsingPOST(xDataStoreID: string, newEmail: string, token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
     public emailExistUsingPOST(xDataStoreID: string, newEmail: string, token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
     public emailExistUsingPOST(xDataStoreID: string, newEmail: string, token: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling emailExistUsingPOST.');
         }

         if (newEmail === null || newEmail === undefined) {
             throw new Error('Required parameter newEmail was null or undefined when calling emailExistUsingPOST.');
         }

         if (token === null || token === undefined) {
             throw new Error('Required parameter token was null or undefined when calling emailExistUsingPOST.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<boolean>(`${this.basePath}/api/public/v1/personal/infos/change/email/exist`,
             newEmail,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * getInfo
     *
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public getInfoUsingGET(xDataStoreID: string, X_LANG: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<PersonalDataDTO>;
     public getInfoUsingGET(xDataStoreID: string, X_LANG: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PersonalDataDTO>>;
     public getInfoUsingGET(xDataStoreID: string, X_LANG: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PersonalDataDTO>>;
     public getInfoUsingGET(xDataStoreID: string, X_LANG: string, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling getInfoUsingGET.');
         }

         if (X_LANG === null || X_LANG === undefined) {
             throw new Error('Required parameter X_LANG was null or undefined when calling getInfoUsingGET.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_LANG !== undefined && X_LANG !== null) {
             headers = headers.set('X-LANG', String(X_LANG));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<PersonalDataDTO>(`${this.basePath}/api/public/v1/personal/infos`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * getInitauthenticationEmail
     *
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public getInitauthenticationEmailUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, observe?: 'body', reportProgress?: boolean): Observable<PersonalAuthDTO>;
     public getInitauthenticationEmailUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PersonalAuthDTO>>;
     public getInitauthenticationEmailUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PersonalAuthDTO>>;
     public getInitauthenticationEmailUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, observe: any = 'body', reportProgress = false ): Observable<any> {



         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
             headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<PersonalAuthDTO>(`${this.basePath}/api/public/v1/personal/authentication/email`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * getNewsletter
      *
      * @param xDataStoreID X-DataStoreID
      * @param uuid uuid
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public getNewsletterUsingGET(xDataStoreID: string, uuid: string, observe?: 'body', reportProgress?: boolean): Observable<PersonalNewslettersStatus>;
     public getNewsletterUsingGET(xDataStoreID: string, uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PersonalNewslettersStatus>>;
     public getNewsletterUsingGET(xDataStoreID: string, uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PersonalNewslettersStatus>>;
     public getNewsletterUsingGET(xDataStoreID: string, uuid: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling getNewsletterUsingGET.');
         }

         if (uuid === null || uuid === undefined) {
             throw new Error('Required parameter uuid was null or undefined when calling getNewsletterUsingGET.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (uuid !== undefined && uuid !== null) {
             queryParameters = queryParameters.set('uuid', <any>uuid);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<PersonalNewslettersStatus>(`${this.basePath}/api/public/v1/personal/newsletters`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * isAnonymization
     *
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isAnonymizationUsingGET(token: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public isAnonymizationUsingGET(token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public isAnonymizationUsingGET(token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public isAnonymizationUsingGET(token: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling isAnonymizationUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/public/v1/personal/anonymization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * logout
     *
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logoutUsingDELETE(token?: string, observe?: 'body', reportProgress?: boolean): Observable<PersonalDataDTO>;
    public logoutUsingDELETE(token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PersonalDataDTO>>;
    public logoutUsingDELETE(token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PersonalDataDTO>>;
    public logoutUsingDELETE(token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<PersonalDataDTO>(`${this.basePath}/api/public/v1/personal/authentication`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveStatusNewsletter
     *
     * @param xDataStoreID X-DataStoreID
     * @param updateStatusNewsletterDTO updateStatusNewsletterDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveStatusNewsletterUsingPOST(xDataStoreID: string, updateStatusNewsletterDTO: UpdateStatusNewsletterDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public saveStatusNewsletterUsingPOST(xDataStoreID: string, updateStatusNewsletterDTO: UpdateStatusNewsletterDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public saveStatusNewsletterUsingPOST(xDataStoreID: string, updateStatusNewsletterDTO: UpdateStatusNewsletterDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public saveStatusNewsletterUsingPOST(xDataStoreID: string, updateStatusNewsletterDTO: UpdateStatusNewsletterDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling saveStatusNewsletterUsingPOST.');
        }

        if (updateStatusNewsletterDTO === null || updateStatusNewsletterDTO === undefined) {
            throw new Error('Required parameter updateStatusNewsletterDTO was null or undefined when calling saveStatusNewsletterUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/public/v1/personal/newsletters/save`,
            updateStatusNewsletterDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * setExportPartnerAuthorization
     *
     * @param xDataStoreID X-DataStoreID
     * @param update update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public setExportPartnerAuthorizationUsingPUT(xDataStoreID: string, update: UpdateExportPartnerAuthorizationDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
     public setExportPartnerAuthorizationUsingPUT(xDataStoreID: string, update: UpdateExportPartnerAuthorizationDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
     public setExportPartnerAuthorizationUsingPUT(xDataStoreID: string, update: UpdateExportPartnerAuthorizationDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
     public setExportPartnerAuthorizationUsingPUT(xDataStoreID: string, update: UpdateExportPartnerAuthorizationDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling setExportPartnerAuthorizationUsingPUT.');
         }

         if (update === null || update === undefined) {
             throw new Error('Required parameter update was null or undefined when calling setExportPartnerAuthorizationUsingPUT.');
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.put<any>(`${this.basePath}/api/public/v1/personal/partnaire/authorization`,
             update,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * updateAdditionalInformations
     *
     * @param xDataStoreID X-DataStoreID
     * @param partner partner
     * @param token token
     * @param update update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAdditionalInformationsUsingPOST(xDataStoreID: string, partner: string, token: string, update: PersonalUpdateDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateAdditionalInformationsUsingPOST(xDataStoreID: string, partner: string, token: string, update: PersonalUpdateDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateAdditionalInformationsUsingPOST(xDataStoreID: string, partner: string, token: string, update: PersonalUpdateDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateAdditionalInformationsUsingPOST(xDataStoreID: string, partner: string, token: string, update: PersonalUpdateDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateAdditionalInformationsUsingPOST.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling updateAdditionalInformationsUsingPOST.');
        }

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling updateAdditionalInformationsUsingPOST.');
        }

        if (update === null || update === undefined) {
            throw new Error('Required parameter update was null or undefined when calling updateAdditionalInformationsUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (partner !== undefined && partner !== null) {
            headers = headers.set('partner', String(partner));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/public/v1/personal/additional-information`,
            update,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateAlertSms
     *
     * @param token token
     * @param value value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAlertSmsUsingPUT(token: string, value: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateAlertSmsUsingPUT(token: string, value: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateAlertSmsUsingPUT(token: string, value: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateAlertSmsUsingPUT(token: string, value: boolean, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling updateAlertSmsUsingPUT.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling updateAlertSmsUsingPUT.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any>value);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/public/v1/personal/alerte-sms`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateInformations
     *
     * @param xDataStoreID X-DataStoreID
     * @param token token
     * @param update update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public updateInformationsUsingPOST(xDataStoreID: string, token: string, update: PersonalUpdateDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
     public updateInformationsUsingPOST(xDataStoreID: string, token: string, update: PersonalUpdateDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
     public updateInformationsUsingPOST(xDataStoreID: string, token: string, update: PersonalUpdateDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
     public updateInformationsUsingPOST(xDataStoreID: string, token: string, update: PersonalUpdateDTO, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (xDataStoreID === null || xDataStoreID === undefined) {
             throw new Error('Required parameter xDataStoreID was null or undefined when calling updateInformationsUsingPOST.');
         }

         if (token === null || token === undefined) {
             throw new Error('Required parameter token was null or undefined when calling updateInformationsUsingPOST.');
         }

         if (update === null || update === undefined) {
             throw new Error('Required parameter update was null or undefined when calling updateInformationsUsingPOST.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<any>(`${this.basePath}/api/public/v1/personal/infos`,
             update,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * validChangeEmail
     *
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validChangeEmailUsingGET(token: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public validChangeEmailUsingGET(token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public validChangeEmailUsingGET(token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public validChangeEmailUsingGET(token: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling validChangeEmailUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/public/v1/personal/infos/change/email`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
